module.exports = __webpack_public_path__ + "fontawesome-webfont.d7c639084f684d66a1bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = 854
// module chunks = 7